import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { constants } from "utils";
import { trackClickedButton } from "utils/analytics";

// The Groups page header (Figma 4422:100023): the title, and at the right
// the student login page link that used to be a card in the side nav. The
// header only renders on the Dashboard, so its page_name is fixed.
const trackStudentLoginLink = () =>
  trackClickedButton("Student Login Page", { page_name: "Dashboard", source: "Groups Header" });

export const GroupsHeader = () => (
  <Row>
    <span>{constants.MANAGE_GROUPS}</span>
    <StudentLoginLink
      href={process.env.REACT_APP_OKOLABS_APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={trackStudentLoginLink}
    >
      Student Login Page
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden="true" />
    </StudentLoginLink>
  </Row>
);

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const StudentLoginLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: inherit;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.25px;
  text-decoration: none;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    color: inherit;
    text-decoration: underline;
  }
`;
